import { render, staticRenderFns } from "./SoftHeader.vue?vue&type=template&id=4fade85f&scoped=true"
import script from "./SoftHeader.vue?vue&type=script&lang=js"
export * from "./SoftHeader.vue?vue&type=script&lang=js"
import style0 from "./SoftHeader.vue?vue&type=style&index=0&id=4fade85f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fade85f",
  null
  
)

export default component.exports